import { css } from '@emotion/core';
import { findLastIndex, unset } from 'lodash';
import { colorsPalette } from '../../../../../styles/colors';
import { MediaQueries } from '../../../../../styles/Grid';
import { typography, fontWeights } from '../../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../../utils/constants';

export const storeLogosContainerCss = css({
  display: 'flex',
  flexWrap: 'wrap',
});
export const storeLogoCss = css({
  display: 'block',
  height: 40,
});

export const storeLinkCss = css({
  marginBottom: 4,
  ':first-of-type': {
    marginRight: '40px',
  },
});
export const commonCss = css({
  marginTop: '16px',
  '.app_txt': {
    marginBottom: '24px',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'left',
  },
  h3: {
    fontSize: '28px',
    lineHeight: '40px',
    letterSpacing: '-0.4000000059604645px',
    textAlign: 'left',
    color: '#fff',
    marginBottom: '0px',
    [MediaQueries.sm]: {
      color: '#fff',
    },
    [MediaQueries.md]: {
      fontSize: '22px',
    },
    [MediaQueries.sm]: {
      fontSize: '22px',
    },
  },
  form: {
    maxWidth: '500px',
    '.ctasubmit': {
      [MediaQueries.md]: {
        paddingRight: '0PX',
      },
    },
    '.mb16': {
      marginBottom: '16px',
      [MediaQueries.md]: {
        paddingRight: '0PX',
      },

      '.TypeAheadDropDown': {
        marginBottom: '0px',
      },
    },

    '.mb16:last-child': { marginBottom: '0px' },

    '.dateinputfield': {
      cursor: 'pointer',
      label: {
        fontSize: '16px',
        color: '#616161',
        display: 'none',
      },

      input: {
        fontSize: '16px',
        color: '#616161',
        cursor: 'pointer',
      },
      div: {
        height: '56px',
        borderRadius: '4px',
        paddingTop: '12px',
        borderColor: '#d7d7d7',
      },
    },

    '.select_sec': {
      label: {
        fontSize: '16px',
        color: '#616161',
      },
      input: {
        fontSize: '16px',
      },
      span: {
        height: '56px',
        fontSize: '16px',
        borderRadius: '4px',
        minHeight: '56px',
        borderColor: '#d7d7d7',
      },
    },
    '.submit_btn': {
      background: '#E52500',
      width: '100%',
      height: '51px',
      color: '#fff',
      borderRadius: '8px',
      border: '0',
      fontSize: '14px',
      lineHeight: '18px',
      textTransform: 'uppercase',
      letterSpacing: '0.875px',
      textAlign: 'center',
      cursor: 'pointer',
    },

    '.submit_btn:hover': {
      background: '#d42705',
      outlineColor: '#d42705',
    },
  },
});

export const DarkModeCss = css({});

export const LightModeCss = css({});
